import React, { useEffect } from 'react'

import { Await, AwaitProps, useAsyncValue, useNavigate } from 'react-router-dom'

import { ErrorResponse } from '@utils/http'

type Redirect = {
  errorCode: string
  redirectUrl: string
}

type Props = {
  redirects: Redirect[]
  children?: React.ReactNode
}

const AwaitWithRedirect: React.FC<Props & Omit<AwaitProps, 'children'>> = ({
  children,
  redirects,
  ...props
}) => {
  return (
    <Await {...props}>
      <Body redirects={redirects}>{children}</Body>
    </Await>
  )
}

export default AwaitWithRedirect

const Body: React.FC<Props> = ({ children, redirects }) => {
  const value = useAsyncValue() as unknown | ErrorResponse
  const navigate = useNavigate()

  const hasErrors = !!(value as ErrorResponse).errors

  useEffect(() => {
    if (hasErrors) {
      const { errors } = value as ErrorResponse
      errors.forEach((err) => {
        const redirect = redirects.find((r) => r.errorCode === err.code)
        if (redirect) {
          navigate(redirect.redirectUrl)
        }
      })
    }
  }, [value])

  if (hasErrors) return null
  return <>{children}</>
}
